import React,{ FC } from 'react';
import { SnackbarState, SNACKBAR_TYPE } from '../../types';

export const SnackbarUi:FC<Pick<SnackbarState, 'text' | 'type'>> = ({ text, type, }) => (
  <div className={`SnackBarComponent ${type === SNACKBAR_TYPE.SUCCESS ? 'Green' : 'Red'}`}>
    <span className="SnackBarComponent__Icon"></span>
    {text}
  </div>
);